import { render } from "./UnlockAnimation.vue?vue&type=template&id=961467ea&scoped=true"
import script from "./UnlockAnimation.vue?vue&type=script&lang=js"
export * from "./UnlockAnimation.vue?vue&type=script&lang=js"

import "./UnlockAnimation.vue?vue&type=style&index=0&id=961467ea&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961467ea"]])

export default __exports__